import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class HomeInformationStore {}

export enum HomeInformationStoreKeys {}
